import React from 'react';
import Hero from '../components/Hero';
import LatestCollections from '../components/LatestCollections';
import BestSeller from '../components/BestSeller';
import { useEffect } from 'react';
import CategorySection from '../components/CategoryCard';
import WhatsAppChatWidget from '../components/WhatsappChatWidget';
import CouponDisplay from '../components/CouponDisplay';
import Navbar from '../components/Navbar';
import RecentlyViewed from '../components/RecentlyViewed';
import TrendingProducts from '../components/TrendingProducts';
import Premium from '../components/Premium';
import HappyCustomersSection from '../components/HappyCustomersSection';

const home = () => {
  useEffect(() => {
    const savedPosition = sessionStorage.getItem('homeScrollPosition');

    requestAnimationFrame(() => {
      setTimeout(() => {
        if (savedPosition !== null) {
          window.scrollTo({
            top: parseInt(savedPosition, 10),
            behavior: 'auto',
          });

          setTimeout(() => {
            sessionStorage.removeItem('homeScrollPosition');
          }, 1000);
        } else {
          // Force go to top if no saved position ✅
          window.scrollTo({
            top: 0,
            behavior: 'auto',
          });
        }
      }, 200);
    });
  }, []);

  return (
    <div>
      <Navbar />
      <Hero />
      <Premium />
      <HappyCustomersSection />

      <TrendingProducts />

      <WhatsAppChatWidget />
      <LatestCollections />
      <RecentlyViewed />
    </div>
  );
};

export default home;
